import axios from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { setupAuthInterceptor } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.configuration_api.terminal_types;

// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// Cached API wrapper
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'configuration_api',
  group: 'terminal_types',
  defaultTtl: '1h',
  hashLargeSegments: true,
  emitMeta: true,
});



// Function to fetch all roles
export const getAllTerminalTypes = async () => {
  return await cachedApi.get('/GetAllTerminalTypes');
  };

  export const getTerminalTypeById = async (Id: string) => {
  return await cachedApi.get(`/GetTerminalTypeById/${Id}`);
  };